import Icon from "@common/controls/Icon/component";
import Image, { type ImageCoverMode } from "@common/controls/Image/component";
import { type PreloaderType } from "@common/controls/Preloader/component";
import { type GenericMap, IconType } from "@common/declarations";
import classnames from "classnames";
import React from "react";

import "./styles.less";

type LoadedInfo = {
  isFailed: boolean;
  isLoaded: boolean;
};
const _loaded: GenericMap<LoadedInfo> = {};

export interface ImageLoaderProps {
  className?: string;
  coverMode?: ImageCoverMode;
  onClick?: () => void;
  preloaderType?: PreloaderType;
  src: string;
}

type State = LoadedInfo;
class ImageLoader extends React.PureComponent<ImageLoaderProps, State> {
  public state = _loaded[this.props.src] ?? {
    isFailed: false,
    isLoaded: false
  };

  public render() {
    const { className } = this.props;

    // TODO: proper solution
    if (this.props.src.indexOf(".svg") >= 0) {
      return <Image src={this.props.src} onClick={this.props.onClick} />;
    }

    const { isFailed, isLoaded } = this.state;

    return (
      <div className={classnames("lazy-img-container", className)}>
        {isFailed ? (
          <Icon icon={IconType.Image} className="no-image" />
        ) : (
          <>
            <Image
              coverMode={this.props.coverMode}
              src={this.props.src}
              onClick={this.props.onClick}
              onLoad={isLoaded ? undefined : this._onLoad}
              onError={this._onError}
            />
          </>
        )}
      </div>
    );
  }

  private _onError = () => {
    const data = {
      isLoaded: true,
      isFailed: true
    };
    _loaded[this.props.src] = data;
    this.setState(data);
  };

  private _onLoad = () => {
    const data = {
      isLoaded: true,
      isFailed: false
    };
    _loaded[this.props.src] = data;
    this.setState(data);
  };
}

export default ImageLoader;
